import createLucideIcon from '../createLucideIcon';

/**
 * @component @name RulerDimensionLine
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMTV2LTMuMDE0IiAvPgogIDxwYXRoIGQ9Ik0xNiAxNXYtMy4wMTQiIC8+CiAgPHBhdGggZD0iTTIwIDZINCIgLz4KICA8cGF0aCBkPSJNMjAgOFY0IiAvPgogIDxwYXRoIGQ9Ik00IDhWNCIgLz4KICA8cGF0aCBkPSJNOCAxNXYtMy4wMTQiIC8+CiAgPHJlY3QgeD0iMyIgeT0iMTIiIHdpZHRoPSIxOCIgaGVpZ2h0PSI3IiByeD0iMSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/ruler-dimension-line
 * @see https://lucide.dev/guide/packages/lucide-preact - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RulerDimensionLine = createLucideIcon('ruler-dimension-line', [
  ['path', { d: 'M12 15v-3.014', key: 'aw6ppf' }],
  ['path', { d: 'M16 15v-3.014', key: '9e0vc7' }],
  ['path', { d: 'M20 6H4', key: '1lfz86' }],
  ['path', { d: 'M20 8V4', key: '1l2g47' }],
  ['path', { d: 'M4 8V4', key: 'sppxzt' }],
  ['path', { d: 'M8 15v-3.014', key: 'when08' }],
  ['rect', { x: '3', y: '12', width: '18', height: '7', rx: '1', key: '1ucwdz' }],
]);

export default RulerDimensionLine;
